const common = {
  'common.loading': 'Lädt...',
  'common.error': 'Ein Fehler ist aufgetreten',
  'common.success': 'Erfolg!',
  'common.cancel': 'Abbrechen',
  'common.confirm': 'Bestätigen',
  'common.submit': 'Senden',
  'common.save': 'Speichern',
  'common.delete': 'Löschen',
  'common.edit': 'Bearbeiten',
  'common.add': 'Hinzufügen',
  'common.remove': 'Entfernen',
  'common.continue': 'Weiter',
  'common.back': 'Zurück',
  'common.next': 'Weiter',
  'common.previous': 'Vorherige',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.search': 'Suchen',
  'common.filter': 'Filter',
  'common.sort': 'Sortieren',
  'common.noResults': 'Seite nicht gefunden',
  'common.selectOne': 'Einen auswählen',
  'common.required': 'Erforderlich',
  'common.optional': 'Optional',
  'common.learnMore': 'Mehr erfahren',
  'common.getStarted': 'Loslegen',
  'common.signUp': 'Registrieren',
  'common.signIn': 'Anmelden',
  'common.dark': 'Dunkel',
  'common.light': 'Hell',
  'common.system': 'System',
  'common.followTheme': 'System-Theme folgen',
  'common.language': 'Sprache',
  'common.viewMore': 'Mehr anzeigen',
  'common.viewLess': 'Weniger anzeigen',
  'common.home': 'Startseite',
  'common.terms': 'Nutzungsbedingungen',
  'common.privacy': 'Datenschutzrichtlinie',
  'common.cookies': 'Cookie-Richtlinie',
  'common.contact': 'Kontakt',
  'common.contactMe': 'Kontaktiere mich',
  'common.profile': 'Profil',
  'common.settings': 'Einstellungen',
  'common.account': 'Konto',
  'common.dashboard': 'Bedienfeld',
  'common.theme.light': 'Helles Theme',
  'common.theme.dark': 'Dunkles Theme',
  'Member Since': 'Mitglied seit',
  'profileNotFound': 'Profil nicht gefunden',
  'common.documentation': 'API-Dokumentation',
  
  // Navigation items
  'nav.home': 'Startseite',
  'nav.join': 'The Club beitreten',
  'nav.tutorials': 'Anleitungen',
  'nav.strategies': 'Strategien',
  'nav.radex': 'Radex Markets',
  'nav.news': 'Nachrichten',
  
  // News translations
  'news.title': 'Neueste Nachrichten',
  'news.description': 'Bleiben Sie mit unseren neuesten Artikeln und Ankündigungen auf dem Laufenden',
  'news.filterByTag': 'Nach Tag filtern',
  'news.allPosts': 'Alle Beiträge',
  'news.noPostsFound': 'Keine Beiträge gefunden',
  'news.viewAllPosts': 'Alle Beiträge anzeigen',
  'news.backToNews': 'Zurück zu Nachrichten',
  'news.relatedPosts': 'Verwandte Beiträge',
  'news.sharePost': 'Diesen Beitrag teilen',
  'news.postNotFound': 'Beitrag nicht gefunden',
  'news.pagination.previous': 'Zurück',
  'news.pagination.next': 'Weiter',
  
  // Social media links - default links
  'social.instagram': 'https://www.instagram.com/theclub.finance/',
  'social.tiktok': 'https://www.tiktok.com/@the.club.fund',
  'social.youtube': 'https://www.youtube.com/@TheClub.finance',
  'social.facebook': 'https://www.facebook.com/profile.php?id=61576120443819',
  'social.telegram': 'https://t.me/theclubfund',
  
  // Footer translations
  'footer.company.description': 'The Club bietet innovative Finanzprodukte und -dienstleistungen, die darauf ausgelegt sind, Ihnen beim Vermögensaufbau und der Erreichung finanzieller Freiheit zu helfen.',
  'footer.theclub': 'The Club',
  'footer.conditions': 'Allgemeine Geschäftsbedingungen',
  'footer.customersupport': 'Kundensupport',
  'footer.contactuswhatsapp': 'WhatsApp',
  'footer.radex': 'Radex Markets',
  'footer.rights': 'Alle Rechte vorbehalten.',
  'footer.terms': 'Bedingungen',
  'footer.privacy': 'Datenschutz',
  'footer.cookies': 'Cookies',
  'footer.contactUs': 'Kontakt',
  'footer.contactMe': 'Kontaktiere mich',
  
  // Radex Markets translations
  'radex.hero.title': 'The Club & Radex Markets Partnerschaft',
  'radex.hero.subtitle': 'Entdecken Sie außergewöhnliche Trading-Möglichkeiten durch unsere strategische Partnerschaft',
  'radex.hero.learnMore': 'Mehr erfahren',
  'radex.hero.visitWebsite': 'Website besuchen',
  'radex.hero.partnership': 'Exklusive Investitionsmöglichkeiten',
  'radex.hero.benefit1': 'Lizenzierter & regulierter Broker',
  'radex.hero.benefit2': 'Modernste Trading-Technologie',
  'radex.hero.benefit3': 'Erweiterte Sicherheitsprotokolle',
  'radex.hero.benefit4': 'Exklusive Club-Mitglieder-Vorteile',
  
  'radex.about.title': 'Über Radex Markets',
  'radex.about.subtitle': 'Ein regulierter Broker, der sich der Sicherheit, Transparenz und modernster Trading-Technologie verschrieben hat',
  'radex.about.establishmentTitle': 'Etablierte Präsenz',
  'radex.about.establishmentText': 'RADEX MARKETS wurde 2019 gegründet und hat seinen Hauptsitz in der Republik Seychellen. Das Unternehmen operiert unter dem Handelsnamen GO Markets International Ltd, einer in der Republik Seychellen eingetragenen Gesellschaft mit der Registrierungsnummer 8425985-1.',
  'radex.about.regulationTitle': 'Lizenziert & Reguliert',
  'radex.about.regulationText': 'Das Unternehmen ist von der Seychelles Financial Services Authority (FSA) unter der Securities Dealer License Nummer SD043 lizenziert und reguliert, was eine sichere und konforme Trading-Umgebung gewährleistet.',
  'radex.about.technologyTitle': 'Erweiterte Technologie',
  'radex.about.technologyText': 'Radex Markets bietet modernste Technologie und eine wettbewerbsfähige Trading-Umgebung, die darauf ausgelegt ist, die Bedürfnisse moderner Trader zu erfüllen, mit zuverlässiger Ausführung und professionellen Tools.',
  'radex.about.transparencyTitle': 'Transparenz & Vertrauen',
  'radex.about.transparencyText': 'Transparenz ist ein Kernwert bei Radex, demonstriert durch klare, ehrliche und mehrsprachige Kommunikation. Bekannt für seine Integrität, zeichnet sich Radex Markets als sichere und vertrauenswürdige Plattform für Trader aus, die Zuverlässigkeit suchen.',
  
  'radex.features.title': 'Warum haben wir Radex Markets gewählt?',
  'radex.features.subtitle': 'Erleben Sie die Vorteile des Handels mit einem Broker, der sich der Exzellenz verschrieben hat',
  'radex.features.security': 'Kundenschutz',
  'radex.features.securityText': 'Robuste Sicherheitsprotokolle zum Schutz von Kundenmitteln und persönlichen Daten, um eine sichere Trading-Umgebung zu gewährleisten.',
  'radex.features.technology': 'Modernste Plattform',
  'radex.features.technologyText': 'Erweiterte Trading-Technologie mit zuverlässiger Ausführung und professionellen Tools für Trader aller Stufen.',
  'radex.features.transparency': 'Vollständige Transparenz',
  'radex.features.transparencyText': 'Klare, ehrliche Kommunikation und zuverlässige Handelsausführung, wobei die höchsten Standards der Transparenz gewahrt werden.',
  'radex.features.global': 'Globaler Zugang',
  'radex.features.globalText': 'Mehrsprachiger Support und Dienstleistungen für Trader aus verschiedenen Regionen und Hintergründen.',
  
  'radex.partnership.title': 'The Club & Radex Markets Partnerschaft',
  'radex.partnership.description': 'Unsere strategische Partnerschaft mit Radex Markets ermöglicht es uns, einzigartige Investitionsmöglichkeiten für unsere Club-Mitglieder anzubieten, indem wir unsere Expertise mit einem regulierten und vertrauenswürdigen Broker kombinieren.',
  'radex.partnership.details': 'Durch diese Zusammenarbeit erhalten Mitglieder von The Club Zugang zu exklusiven Trading-Bedingungen, verbessertem Kontomanagement und spezialisiertem Support von beiden Organisationen. Die Partnerschaft zwischen Radex Markets und The Club basiert auf gemeinsamen Werten von Transparenz, Sicherheit und der Bereitstellung außergewöhnlicher Werte für unsere Community.',
  'radex.partnership.contactUs': 'Für Details kontaktieren',
  'radex.partnership.visitRadex': 'Radex Markets besuchen',
  'radex.partnership.benefitsTitle': 'Partnerschaftsvorteile',
  'radex.partnership.benefit1Title': 'Erhöhte Sicherheit',
  'radex.partnership.benefit1Text': 'Handeln Sie mit Vertrauen, weil Sie wissen, dass Ihre Mittel durch die robusten Sicherheitsprotokolle von Radex Markets geschützt sind.',
  'radex.partnership.benefit2Title': 'Exklusive Produkte',
  'radex.partnership.benefit2Text': 'Zugang zu spezialisierten Investitionsprodukten und Trading-Bedingungen, die nur für Club-Mitglieder verfügbar sind.',
  'radex.partnership.benefit3Title': 'Professioneller Support',
  'radex.partnership.benefit3Text': 'Erhalten Sie engagierte Unterstützung von den Teams von The Club und Radex Markets für eine verbesserte Trading-Erfahrung.',
  
  // Documentation translations
  'docs.title': 'API-Dokumentation',
  'docs.introduction': 'Einführung',
  'docs.introDescription': 'Diese Anwendung verwendet GraphQL als flexible Datenzugriffsschicht, unterstützt von der pg_graphql-Erweiterung in Supabase.',
  'docs.benefits': 'Vorteile dieses Ansatzes beinhalten:',
  'docs.benefitDecoupling': 'Entkopplung des Frontends vom direkten Datenbankzugriff',
  'docs.benefitTypeSafety': 'Starke Typsicherheit in der gesamten Anwendung',
  'docs.benefitFlexibility': 'Flexibilität zum Wechseln von Backend-Implementierungen mit minimalen Änderungen',
  'docs.architecture': 'Architektur-Übersicht',
  'docs.architectureDescription': 'Die Anwendung verwendet eine geschichtete Architektur, die Belange trennt und Flexibilität bietet:',
  'docs.serviceLayer': 'Service-Abstraktionsschicht',
  'docs.serviceLayerDescription': 'Die Service-Schicht bietet eine konsistente Schnittstelle unabhängig von der zugrunde liegenden Implementierung, wodurch die Anwendung zwischen direkten Supabase-Aufrufen und GraphQL-Abfragen wechseln kann, ohne den Anwendungscode zu ändern.',
  'docs.schema': 'GraphQL-Schema',
  'docs.schemaDescription': 'Das GraphQL-Schema wird automatisch aus der Datenbankstruktur von pg_graphql generiert, mit einigen zusätzlichen benutzerdefinierten Resolvern für spezifische Bedürfnisse:',
  'docs.implementationGuide': 'Implementierungsleitfaden',
  'docs.frontendImplementation': 'Frontend-Implementierung',
  'docs.frontendImplementationDescription': 'Um mit der GraphQL-API vom Frontend zu interagieren, verwenden Sie Apollo Client:',
  'docs.serviceFactory': 'Service-Factory',
  'docs.serviceFactoryDescription': 'Das Service-Factory-Muster ermöglicht einfaches Wechseln zwischen verschiedenen Service-Implementierungen:',
  'docs.switchingBackends': 'Backend-Wechsel',
  'docs.switchingBackendsDescription': 'Um zwischen verschiedenen Backend-Implementierungen zu wechseln, rufen Sie die setServiceImplementation-Funktion auf:',
  'docs.backendImplementation': 'Backend-Implementierung',
  'docs.backendImplementationDescription': 'Das Backend verwendet Supabase mit der pg_graphql-Erweiterung, um eine GraphQL-API bereitzustellen:',
  'docs.pgGraphql': 'pg_graphql-Erweiterung',
  'docs.pgGraphqlDescription': 'Die pg_graphql-Erweiterung generiert automatisch eine GraphQL-API aus Ihrem Datenbankschema:',
  'docs.alternativeBackends': 'Alternative Backends',
  'docs.alternativeBackendsDescription': 'Um alternative Backends zu implementieren, erstellen Sie neue Service-Implementierungen, die den in der Service-Factory definierten Service-Schnittstellen entsprechen.',

  // Error translations
  'error.defaultTitle': 'Ein Fehler ist aufgetreten',
  'error.defaultMessage': ' ',
  'error.profileInvalidTitle': 'Ein Fehler ist aufgetreten',
  'error.profileInvalidMessage': 'Das Benutzerprofil ist ungültig',
  'error.goHome': 'Zur Startseite',
  'error.contactSupport': 'Support kontaktieren',
};

const calendar = {
  'calendar.january': 'Januar',
  'calendar.february': 'Februar',
  'calendar.march': 'März',
  'calendar.april': 'April',
  'calendar.may': 'Mai',
  'calendar.june': 'Juni',
  'calendar.july': 'Juli',
  'calendar.august': 'August',
  'calendar.september': 'September',
  'calendar.october': 'Oktober',
  'calendar.november': 'November',
  'calendar.december': 'Dezember',
  'calendar.months.january': 'Jan',
  'calendar.months.february': 'Feb',
  'calendar.months.march': 'Mär',
  'calendar.months.april': 'Apr',
  'calendar.months.may': 'Mai',
  'calendar.months.june': 'Jun',
  'calendar.months.july': 'Jul',
  'calendar.months.august': 'Aug',
  'calendar.months.september': 'Sep',
  'calendar.months.october': 'Okt',
  'calendar.months.november': 'Nov',
  'calendar.months.december': 'Dez',
  'calendar.weekdays.monday': 'Mo',
  'calendar.weekdays.tuesday': 'Di',
  'calendar.weekdays.wednesday': 'Mi',
  'calendar.weekdays.thursday': 'Do',
  'calendar.weekdays.friday': 'Fr',
  'calendar.weekdays.saturday': 'Sa',
  'calendar.weekdays.sunday': 'So',
};

export default {
  ...common,
  ...calendar,
};
